var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6376 74.7295V80.3073H63.3623V74.7295H52.7791V44.9396C52.7951 44.2218 52.6656 43.5081 52.3982 42.8417C52.1309 42.1753 51.7313 41.57 51.2236 41.0623C50.7159 40.5546 50.1106 40.155 49.4442 39.8877C48.7778 39.6203 48.0642 39.4908 47.3463 39.5069H39.2717V45.0807H47.2052V74.7138L36.6376 74.7295Z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0964 23.8044C45.0964 24.6177 45.3376 25.4127 45.7894 26.0888C46.2412 26.765 46.8833 27.292 47.6347 27.6032C48.386 27.9145 49.2127 27.9959 50.0104 27.8372C50.808 27.6786 51.5406 27.287 52.1157 26.7119C52.6907 26.1369 53.0823 25.4042 53.241 24.6066C53.3996 23.809 53.3182 22.9823 53.007 22.2309C52.6958 21.4796 52.1688 20.8374 51.4926 20.3856C50.8164 19.9338 50.0214 19.6927 49.2082 19.6927C48.6665 19.6864 48.129 19.7884 47.6272 19.9928C47.1255 20.1972 46.6697 20.4998 46.2867 20.8829C45.9036 21.266 45.6009 21.7218 45.3965 22.2235C45.1921 22.7252 45.0901 23.2627 45.0964 23.8044Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.965ab881f384fca7011c56737852abbc.svg";
export { ForwardRef as ReactComponent };